<template>
  <div id="login" class="fullHeight">
    <mu-flexbox align="center" justify="center" class="fullHeight">
      <mu-flexbox-item>
        <mu-row>
          <mu-col desktop="33" tablet="25"></mu-col>
          <mu-col desktop="33" tablet="50" class="animated fadeInDown">
            <mu-card>
              <mu-card-header :title="$t('message.forgotPasswordTitle')"
                              :subTitle="$t('message.forgotPasswordSubTitle')"
                              titleClass="blueTitle largeTitle"></mu-card-header>
              <mu-card-text>
                <form @submit.prevent="submitForm" name="login">
                  <mu-text-field
                    name="email"
                    v-validate="'required|email'"
                    data-vv-name="email"
                    data-vv-value-path="inputValue"
                    :data-vv-as="$t('message.accountPreferencesEmail')"
                    data-vv-validate-on="none"
                    :errorText="errors.first('email')"
                    :label="$t('message.accountPreferencesEmail')"
                    type="email"
                    v-model="email"
                    :hintText="$t('message.placeholderEmail')"
                    fullWidth
                  ></mu-text-field>
                  <button type="submit" style="display: none"></button>
                  <mu-raised-button
                    :disabled="isSending"
                    @click.native="submitForm"
                    type="button"
                    :label="$t('message.resetText')"
                    secondary>
                  </mu-raised-button>
                  <mu-row class="noAccount">
                    <mu-col>
                      {{$t('message.loginNoAccountYet')}}
                    </mu-col>
                    <mu-col>
                      <router-link to="/register">{{$t('message.loginSignUp')}}</router-link>
                    </mu-col>
                  </mu-row>
                </form>
                <mu-row class="noAccount last">
                  <mu-col>
                    <router-link to="/login">{{$t('message.forgotPasswordSignIn')}}</router-link>
                  </mu-col>
                </mu-row>
              </mu-card-text>
            </mu-card>
          </mu-col>
          <mu-col desktop="33" tablet="25"></mu-col>
        </mu-row>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>
  import LoginApi from '../../api/Login'

  export default {
    data() {
      return {
        email: null,
        isSending: false
      }
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid === true) {

            self.isSending = true;

            LoginApi.ResetPassword(self.email)
              .then(function (response) {
                self.isSending = false;

                self.$alert({
                  title: self.$t('message.forgotPasswordEmailSentMessageTitle'),
                  text: self.$t('message.forgotPasswordEmailSendMessageSubTitle') + ' ' +  self.email,
                  type: "success",
                  showCancelButton: false,
                  confirmButtonColor: "white"
                })


              })
              .catch(function (error) {
                self.isSending = false;
                self.$toastr.error(self.$t('message.forgotPasswordEmailNotFound'));
              });
          }
        })
      }
    }
  }
</script>
<style scoped>

  .last {
    margin-bottom: 0px !important;
  }
  .fullHeight {
    height: 100%;
    min-height: 100%;
    max-height: 100%;
  }
  .noAccount {
    font-size: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: #9B9B9B;
  }

  a {
    color: #0179d5 !important;
    text-decoration: underline !important;
  }
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?833b0606